function injectStyle (context) {
  require("!!vue-style-loader!css-loader?minimize!../../../../../../home/node/site/node_modules/vue-loader/lib/style-compiler/index?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!../../../../../../home/node/site/node_modules/vue-loader/lib/selector?type=styles&index=0!./Serp.vue")
}
/* script */
export * from "!!babel-loader!../../../../../../home/node/site/node_modules/vue-loader/lib/selector?type=script&index=0!./Serp.vue"
import __vue_script__ from "!!babel-loader!../../../../../../home/node/site/node_modules/vue-loader/lib/selector?type=script&index=0!./Serp.vue"
/* template */
import {render as __vue_render__, staticRenderFns as __vue_static_render_fns__} from "!!../../../../../../home/node/site/node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-5623efe4\",\"hasScoped\":false,\"optionsId\":\"0\",\"buble\":{\"transforms\":{}}}!../../../../../../home/node/site/node_modules/vue-loader/lib/selector?type=template&index=0!./Serp.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
import normalizeComponent from "!../../../../../../home/node/site/node_modules/vue-loader/lib/runtime/component-normalizer"
var Component = normalizeComponent(
  __vue_script__,
  __vue_render__,
  __vue_static_render_fns__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports
